import { authRoutes } from '../routes'
import { guardarSesion } from '../routes/sesiones.routes'
import { logsDatabase } from '../indexedDB'

const AuthService = {
    /**
     * Authenticate user, log action, and start session.
     * @param {string} username
     * @param {string} password
     * @param {string} deviceId
     * @returns {Promise<{user: object, token: string, session: object}>}
     */
    login: async (username, password, deviceId) => {
        try {
            const response = await authRoutes.login(username, password)

            if (response.data && response.data.changePasswordRequired) {
                return {
                    changePasswordRequired: true,
                    passProvisory: response.data.passProvisory,
                    user: response.data.user
                }
            }

            const user = response.data.user
            const token = response.data.access_token

            // Log to IndexedDB
            const log = {
                user: `${user.name} ${user.lastName}`,
                userId: user.id,
                id: Date.now(),
                type: 'Login'
            }
            await logsDatabase.agregar(log)

            // Session tracking
            const newSessionData = {
                id: deviceId,
                online: true,
                dateLogin: new Date(),
                userId: user.id
            }

            // Note: guardarSesion returns the axios response
            const sessionResponse = await guardarSesion(newSessionData)

            return {
                user,
                token,
                session: sessionResponse.data,
                fullResponse: response // Return full response in case needed
            }
        } catch (error) {
            console.error('AuthService Login Error:', error)
            throw error
        }
    },

    /**
     * Logout user, log action, and update session.
     * @param {object} user
     * @param {object} currentSessionData
     * @param {string} deviceId
     */
    logout: async (user, currentSessionData, deviceId) => {
        try {
            // Log to IndexedDB
            if (user) {
                const log = {
                    user: `${user.name} ${user.lastName}`,
                    userId: user._id || user.id,
                    id: Date.now(),
                    type: 'Logout'
                }
                await logsDatabase.agregar(log)
            }

            // Update Session
            let updatedSession = null
            if (currentSessionData && currentSessionData._id) {
                const sessionPayload = {
                    _id: currentSessionData._id,
                    id: deviceId,
                    dateLogin: currentSessionData.dateLogin || new Date().toString(),
                    dateLogout: new Date().toISOString(), // Use ISO string for consistency
                    online: false,
                    userId: user ? (user._id || user.id) : null
                }

                const response = await guardarSesion(sessionPayload)
                updatedSession = response.data
            }

            // Llama a la api de logout si es necesario aunque no existe en si xd
            /* if (user) {
                await authRoutes.logout(user)
            } */

            return updatedSession
        } catch (error) {
            console.error('AuthService Logout Error:', error)
        }
    },

    /**
     * Log a user activity (e.g. page visit).
     * @param {object} user
     * @param {string} activityType
     */
    logActivity: async (user, activityType) => {
        if (!user) return
        const log = {
            user: `${user.name} ${user.lastName}`,
            userId: user._id || user.id,
            id: Date.now(),
            type: activityType
        }
        await logsDatabase.agregar(log)
    }
}

export default AuthService
